import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createButtonStyles = ({
  palette,
  spacing,
  typography,
  borderRadius,
  boxShadows,
}: Theme) => {
  return {
    root: css({
      border: "none",
      position: "relative",
      padding: spacing(2),
      minHeight: 40,
      minWidth: 110,
      fontSize: typography.pxToRem(13),
      fontWeight: typography.fontWeight.semiBold,
      cursor: "pointer",
      fontFamily: typography.fonts.body,
      borderRadius: borderRadius.default,
    }),
    withShadow: css({
      boxShadow: boxShadows.button,
      "&:disabled": {
        boxShadow: "none",
      },
    }),
    primary: css({
      backgroundColor: palette.primary.light,
      color: palette.primary.text,

      "&:hover, &:focus": {
        backgroundColor: palette.primary.main,
        color: palette.primary.textDark,
      },

      "&:active": {
        backgroundColor: palette.primary.dark,
        color: palette.primary.textDark,
      },
    }),
    secondary: css({
      backgroundColor: palette.secondary.light,
      color: palette.secondary.text,

      "&:hover, &:focus": {
        backgroundColor: palette.secondary.main,
        color: palette.secondary.textDark,
      },

      "&:active": {
        backgroundColor: palette.secondary.dark,
        color: palette.secondary.textDark,
      },
    }),
    tertiary: css({
      backgroundColor: palette.tertiary.light,
      color: palette.tertiary.text,

      "&:hover, &:focus": {
        backgroundColor: palette.tertiary.main,
        color: palette.tertiary.textDark,
      },

      "&:active": {
        backgroundColor: palette.tertiary.dark,
        color: palette.tertiary.textDark,
      },
    }),
    warning: css({
      backgroundColor: palette.error.light,
      color: palette.error.text,

      "&:hover, &:focus": {
        backgroundColor: palette.error.main,
        color: palette.error.textDark,
      },

      "&:active": {
        backgroundColor: palette.error.dark,
        color: palette.error.textDark,
      },
    }),
    text: css({
      margin: 0,
      padding: 0,
      minWidth: 0,
      minHeight: "auto",
      fontSize: "inherit",
      fontWeight: typography.fontWeight.semiBold,
      color: palette.secondary.textDark,
      backgroundColor: "transparent",
      border: 0,
      cursor: "pointer",
      textDecoration: "underline",
      "&:hover, &:focus": {
        color: grey[800],
      },
      "&:active": {
        color: grey[900],
      },
      "&:disabled": css({
        color: palette.disabled.text,
        cursor: "not-allowed",
      }),
    }),
    loading: css({
      cursor: "not-allowed",
    }),

    disabled: css({
      backgroundColor: palette.disabled.background,
      color: palette.disabled.text,
      cursor: "not-allowed",

      "&:hover, &:focus": {
        backgroundColor: palette.disabled.background,
        color: palette.disabled.text,
      },
    }),
  };
};
